export const STUDENT_SUPPORT_SUBMIT = '/student-support-submit'
export const STUDENT_SUPPORT = '/student-support'
